import BaseAnnotationLayer from "./BaseAnnotationLayer";
import {openTopApp, updateActiveAnnoDrawer, updateActiveMap} from "../../../redux_actions/gamma.state.action";
import {updateSelectedAnnotationsList} from "../../../redux_actions/maps.state.action";
import {store} from "../../../helper/store";
import {annotationsApp} from "../app_maker";
import {expandAnnotation} from "../../../redux_actions/triggers.action";
import Line from "../drawTools/Line";
import Circle from "../drawTools/Circle";
import FreeLine from "../drawTools/FreeLine";
import FreeHand from "../drawTools/FreeHand";
import Rectangle from "../drawTools/Rectangle";
import Polygon from "../drawTools/Polygon";
import MagicTool from "../drawTools/MagicTool";
import VectorLayer from "ol/layer/Vector";
import Select from 'ol/interaction/Select'
import Arrow from "../drawTools/Arrow";
import Point from "../drawTools/Point";

class AnnotationLayer extends BaseAnnotationLayer {
	id = annotationsApp.id;
	label = "Annotation Layer";
	drawer = annotationsApp.drawer;
	tools = [Point, Arrow, Line, FreeLine, Circle, FreeHand, Rectangle, Polygon, MagicTool];

	setDrawCompleteState = () =>
		this.setState({visible: this.layer.getVisible(), drew: true},
			() => store.dispatch(updateActiveAnnoDrawer(this.drawer)));

	onFeatureSelect = (feature) => {
		if(!feature) return;
		store.dispatch(updateActiveMap(this.props.map.get('id')));
		store.dispatch(openTopApp(annotationsApp));
		store.dispatch(expandAnnotation(feature.getId()));
		store.dispatch(updateSelectedAnnotationsList(this.props.map.get('id'), [feature.getId()], true));
	}

	onFeaturesDeselect = (features) => {
		let annotationsUpdated = features.map(feature => feature.getId());
		store.dispatch(updateSelectedAnnotationsList(this.props.map.get('id'), annotationsUpdated, false));
	}

	init = () => {
		this.layer = this.props.map.getLayers().getArray().find(layer => layer.get("id") === this.id) ||
			this.createLayer();
		
		this.selectInteraction = new Select({
			layers: [this.layer],
			style: null
		});

		this.selectInteraction.on('select', event => {
			this.onFeatureSelect(event.selected[0]);
			this.onFeaturesDeselect(event.deselected)
		});

		this.selectInteraction.on('deselect', event => {
			this.onFeaturesDeselect(event.deselected)
		});
		  	  
		this.props.map.addInteraction(this.selectInteraction);

		return this.layer;
	}

	createLayer = () => new VectorLayer({
		id: this.id,
		source: this.getSource(),
		extent: this.props.map.getView().getProjection().getExtent(),
		visible: this.defaultVisible || false,
		zIndex: 1000000,
		style: this.style,
		drew: false,
	});
}

export default AnnotationLayer;
